import React, { Component } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import {  NavLink } from "react-router-dom";
import { SidebarWidth } from "../Settings";
import homeIcon from "../images/homeIcon.png";
import moneyIcon from "../images/moneyIcon.png";
import spendingIcon from "../images/spendingIcon.png";
import footprintIcon from "../images/cfIcon.png";

const routes = [
  { id:0, text: "Home", route: "/home", icon: homeIcon },
  {  id:1, text: "Money", route: "/money", icon: moneyIcon },
  {  id:2, text: "Spending", route: "/spending", icon: spendingIcon },
  {  id:3, text: "Carbon Footprint", route: "/carbon-footprint", icon: footprintIcon },
];

const drawer = (
  <div>
    <Toolbar
      sx={{
        minHeight: { xs: 0, sm: "60px" },
      }} />
    <List p={0}
      sx={{
        display: { xs: "flex", sm: "block" },
        alignItems:"flex-end",
        p: 0
      }}
    >
      {routes.map((element, index) => (
        <ListItem
          button
          key={element.id}
          component="li"
          sx={{p:0,display:"block"}}
        >
          
          <NavLink
            to={element.route}
            className="menuItem"
            activeClassName="isActiveMenuItem"
            exact={element.id === 0 ? true:false }
            style={{
            textDecoration: "none", 
            padding: { sm: 2 },
            display: "flex",
            alignItems: "center", 
            justifyContent:"center", 
            flexDirection:"column"}}
          >
            <ListItemIcon
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                mb: { xs: 0.5, sm:1},
                minHeight: "auto",
                width: { xs: "20%", sx: "100%" }
              }}
            >
              <img src={element.icon} alt="Icon" style={{ height: "1.8rem" }} />
            </ListItemIcon>
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "0.7rem", sm:"0.8rem" },
                textAlign: "center",
                mt: "2",
                color: "black",
                fontWeight: "fontWeightBold",
              }}
            >
              {element.text}
            </Typography>
          </NavLink>
        </ListItem>
      ))}
    </List>
  </div>
);

export class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeLink:0
    }
  };

  handleClick = (index) => {
    this.setState({activeLink:index})
  }

  render() {
    return (
      <Drawer
        className="sideBar"
        variant="permanent"
        sx={{
          "& .MuiDrawer-paper": {
            top: { xs: "auto", sm: 0 },
            bottom: { xs: 0, sm: "auto" },
            width: { xs: "100%", sm: SidebarWidth },
            height: { xs: "auto", sm: "100vh" },
            display: { xs: "flex", sm: "block" },
            overflow: "hidden",
            zIndex: 999,
            borderRight:{xs:0,sm:"1px solid rgba(0, 0, 0, 0.12)"},
            borderTop:{xs:"1px solid rgba(0, 0, 0, 0.12)"}
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    );
  }
}

export default Sidebar;
